/**
 * @author David Ontiveros.
 */
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
// Excel export imports
import * as XLSX from 'xlsx';
import { BookType } from 'xlsx';

// type AOA = Array<Array<any>>;

@Injectable()
export class ExportToExcelService {
  // Excel export configuration.
  /*data: AOA = [
		['Row 1', 'Row 1'],
		['Row 2', 'Row 2']
	];*/
  /*private jsondata = [
		{S: 1, h: 2, e: 3, e_1: 4, t: 5, J: 6, S_1: 7},
		{S: 2, h: 3, e: 4, e_1: 5, t: 6, J: 7, S_1: 8}
	];*/

  /**
   * Exports to excel spreadsheet from json datasource.
   * @param jsondata json object data source.
   * @param {string} filename name of file.
   * @param {BookType} extension
   */
  exportFromJsonToExcel(
    jsondata: any,
    filename: string,
    extension: BookType
  ): void {
    // generate worksheet
    // const workSheet = XLSX.utils.aoa_to_sheet(this.data);
    const workSheet = XLSX.utils.json_to_sheet(jsondata);

    // generate workbook and add the worksheet
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet1');

    // save to file
    let wopts: XLSX.WritingOptions = { bookType: extension, type: 'binary' };
    const workBookOut = XLSX.write(workBook, wopts);
    saveAs(new Blob([this.s2ab(workBookOut)]), filename);
  }

  private s2ab(s: string): ArrayBuffer {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
}
